import {TABLE_CONFIG_DEFAULT} from '@app/ng-zorro/nz-config/nz-common.config';

export class PaginationModel {
  pageNumber: number = 1;
  pageSize: number = TABLE_CONFIG_DEFAULT.pageSize;

  sortBy?: string;
  ascOrDesc?: string;
}
